import { data } from '../../svg/Building/data';
import { makeIcon } from '../makeIcon';

export const Building = makeIcon(data, 'building', 'Building');

export default Building;
